<template src="./template.html"></template>

<script>
  import { find, isUndefined } from 'lodash'
  import ModuleMapping from '@/config/modules-mapping'

  export default {
    name: 'ComponentLoader',
    components: {
      ...ModuleMapping.modulesImport,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      componentType: {
        type: String,
        default: () => null,
      },
      options: {
        type: Object,
        default: () => {},
      },
      commentsActive: Boolean,
      moduleId: Number,
    },
    computed: {
      componentLoader() {
        const type = find(ModuleMapping.modulesMapping(), m => m.type === this.componentType)
        return !isUndefined(type) ? type.component : false
      },
    },
  }
</script>
